import { CreativeInfoItem, Importance } from '@blisspointmedia/bpm-types/dist/Creative';
import { creativeMatchesTag } from './creative-insights-utils';
import { BETA_BAR_SIZE } from './tags-chart-constants';

export interface TagBarDatum {
  name: string;
  val: number;
  quantity: number;
  spend: number;
}

// Narrow bars get smaller labels; a bar too narrow to label (or not yet measured) gets none.
export const getLabelFontSize = (barWidth: number): number =>
  barWidth > 0 ? Math.max(0, 15 - 100 / barWidth) : 0;

// Recharts shrinks a fixed-size bar to 90% of its band when the band is narrower than the bar.
export const getBetaBarWidth = (plotWidth: number, categoryCount: number): number => {
  const bandSize = plotWidth / categoryCount;
  return bandSize > BETA_BAR_SIZE ? BETA_BAR_SIZE : bandSize * 0.9;
};

export const formatCurrency = (value: number): string => {
  if (value >= 1_000_000) {
    return `$${(value / 1_000_000).toFixed(1)}M`;
  }
  if (value >= 1_000) {
    return `$${(value / 1_000).toFixed(1)}K`;
  }
  return `$${value.toFixed(1)}`;
};

// One bar per tag that aired, with the airings and spend of the creatives carrying that tag.
export const buildTagBarData = (
  tagImportances: Importance[],
  attribute: string,
  creativeInfoList: CreativeInfoItem[],
  attributeTypeBinomial: Record<string, boolean>
): TagBarDatum[] =>
  tagImportances
    .map(({ name, val }) => {
      const taggedCreatives = creativeInfoList.filter(creative =>
        creativeMatchesTag(creative, attribute, name, attributeTypeBinomial)
      );
      return {
        name,
        val,
        quantity: taggedCreatives.reduce((sum, creative) => sum + creative.numSpots, 0),
        spend: taggedCreatives.reduce((sum, creative) => sum + creative.spend, 0)
      };
    })
    .filter(tag => tag.quantity > 0);
